<template>
  <div id="service-packs-budget">
        <base-modal v-model="showThePacksList" :persistent="true" :title="$t('module-budget.main-budget.service-pack.title')" modal-width="1400px">
            <template v-slot:modal-body>
                <v-col cols="12">
                    <v-col cols="12" class="d-flex justify-end p-0" :class="hideFooterAndSearch ? 'mb-3' : ''">
                        <v-btn
                            fab
                            dark
                            x-small
                            :color="blockAddBtn ? '#eeeeee' : '#F59534'"
                            rounded
                            class="add-btn"
                            style="min-width: 30px !important"
                            :style="blockAddBtn ? 'cursor: no-drop' : ''"
                            @click="addNewRow"
                            :readonly="blockAddBtn"
                        >
                            <v-icon :style="blockAddBtn ? 'color: grey' : 'color: white'">
                                mdi-plus
                            </v-icon>
                        </v-btn>
                        <span @click="blockAddBtn ? '' : addNewRow()" class="ml-3 btn-span mt-1" style="cursor: pointer" :style="blockAddBtn ? 'cursor: no-drop' : ''">{{$t('module-budget.main-budget.service-pack.add-service-pack')}}</span>
                    </v-col>
                    <div class="ml-16" :class="hideFooterAndSearch ? 'd-none' : ''">
                        <SearchForm type="textonly" :showAdvancedSearch="false" @on-search="onSearchByText"/>
                    </div>
                    <v-data-table
                        v-show="tablePackIsReady"
                        class="tablepackservice"
                        v-model="selected"
                        item-key="entityPackageServiceId"
                        :headers="servicePacksHeaders"
                        :items="servicePacksItems"
                        :show-select="isSelectable"
                        :page="page"
                        :pageCount="numberOfPages"
                        :options.sync="options"
                        :server-items-length="totalItems"
                        :footer-props="{
                            showFirstLastPage: true,
                            'items-per-page-options': [5, 10, 20]
                        }"
                        :hide-default-footer='hideFooterAndSearch'
                    >
                        <template v-slot:[`item.description`]="{ item }">
                            <v-form @submit.prevent v-if="item.editable" v-model="validations.desc">
                                <v-text-field
                                    v-model="item.description"
                                    :placeholder="$t('module-budget.main-budget.service-pack.desc-placeholder')"
                                    :rules="formRules.defaultRules"
                                    class="mt-2"
                                ></v-text-field>
                            </v-form>

                            <span v-else>
                                {{item.description}}
                            </span>
                        </template>

                        <template v-slot:[`item.reference`]="{ item }">
                            <v-form @submit.prevent v-if="item.editable" v-model="validations.ref">
                                <v-text-field
                                    v-if="item.editable"
                                    v-model="item.reference"
                                    :placeholder="$t('module-budget.main-budget.service-pack.ref-placeholder')"
                                    :rules="formRules.defaultRules"
                                    class="mt-2"
                                ></v-text-field>
                            </v-form>

                            <span v-else>
                                {{item.reference}}
                            </span>
                        </template>

                        <template v-slot:[`item.isActive`]="{ item }">
                            <v-switch
                                class="switch-user"
                                v-model="item.isActive"
                                :class="item.isActive ? 'custom-red' : ''"
                                color="green"
                                small
                                :label="item.isActive ? $t('backoffice.general.active-status') : $t('backoffice.general.inactive-status')"
                                v-if="item.editable"
                            ></v-switch>
                            <v-chip
                                v-else
                                :color="getColor(item.isActive)"
                                pill
                                dark
                                small
                                class="status-column"
                            >
                                {{ item.isActive == true ? $t('backoffice.general.active-status') : $t('backoffice.general.inactive-status')}}
                            </v-chip>
                        </template>

                        <template v-slot:[`item.totalTime`]="{ item }">
                            <!-- <v-form v-if="item.editable" v-model="validations.time">
                                <v-menu
                                    v-if="item.editable"
                                    ref="hours"
                                    v-model="hoursControlMenu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    :return-value.sync="item.totalTime"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="item.totalTime"
                                            :placeholder="$t('module-budget.main-budget.service-pack.time-placeholder')"
                                            append-icon="mdi-clock-time-four-outline"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            @click:append="hoursControlMenu = true"
                                        ></v-text-field>
                                    </template>
                                    <v-time-picker
                                        v-if="hoursControlMenu"
                                        v-model="item.totalTime"
                                        full-width
                                        format="24hr"
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="hoursControlMenu = false"
                                        >
                                            {{$t('cancel')}}
                                        </v-btn>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="$refs.hours.save(item.totalTime)"
                                        >
                                            {{$t('ok')}}
                                        </v-btn>
                                    </v-time-picker>
                                </v-menu>
                            </v-form> -->

                            <!-- <span v-else>
                                {{item.totalTime | formatTime}}
                            </span> -->
                            <span>
                                {{item.totalTime | formatTime}}
                            </span>
                        </template>

                        <template v-slot:[`item.totalPrice`]="{ item }">
                            <!-- <v-form v-if="item.editable" v-model="validations.price">
                                <v-text-field
                                    v-if="item.editable"
                                    v-model="item.totalPrice"
                                    :placeholder="$t('module-budget.main-budget.service-pack.price-placeholder')"
                                    :rules="formRules.defaultRules"
                                    type="number"
                                    @keypress="onlyNumberRule"
                                    append-icon="mdi-currency-eur"
                                ></v-text-field>
                            </v-form> -->

                            <!-- <span v-else>
                                {{ Number(item.totalPrice) | currency }}
                            </span> -->
                            <span>
                                {{ Number(item.totalPrice) | currency }}
                            </span>
                        </template>

                        <template v-slot:[`item.isDefaultQuotation`]="{ item, index }">
                            <v-switch
                                class="switch-user"
                                v-model="item.isDefaultQuotation"
                                :class="item.isDefaultQuotation ? 'custom-red' : ''"
                                color="green"
                                small
                                :label="item.isDefaultQuotation ? $t('backoffice.general.active-status') : $t('backoffice.general.inactive-status')"
                                v-if="item.editable"
                            ></v-switch>
                                <span v-else :id="item.reference+'_check_'+index">
                                    <img src="/images/_SVGs/bo/check.svg"  onload="SVGInject(this)" width="15" height="15" fill="green" v-if="item.isDefaultQuotation" />
                                </span>
                        </template>

                        <template v-slot:[`item.actions`]="{ item, index }">
                            <div class="div-actions">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span :id="item.reference+'_check_edit_'+index" @click="onEditRow(item.entityPackageServiceId)" style="cursor: pointer;" v-bind="attrs" v-on="on" v-show="item.editable == false">
                                            <img src="/images/_SVGs/bo/edit_pencil.svg" onload="SVGInject(this)" width="20" height="20"/>
                                        </span>
                                    </template>
                                    <span>{{$t('module-budget.main-budget.service-pack.edit-pack')}}</span>
                                </v-tooltip>
                                <span  v-show="item.editable == false">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span :id="item.reference+'_remove_'+index" @click="onDeleteRow(item)" style="cursor: pointer;" class="mr-2 p-0" v-bind="attrs" v-on="on">
                                            <img src="/images/_SVGs/bo/remove.svg" alt="remover" onload="SVGInject(this)" width="30" height="30" class="circle"/>
                                        </span>
                                    </template>
                                    <span>{{$t('module-budget.main-budget.service-pack.remove-pack')}}</span>
                                </v-tooltip>
                                    <!-- <template v-else>
                                        <span style="cursor: no-drop !important;" class="mr-2 p-0" >
                                            <img src="/images/_SVGs/bo/remove-block.svg" alt="remover" onload="SVGInject(this)" width="30" height="30" class="circle nodrop"/>
                                        </span>
                                    </template> -->
                                </span>
                                <!-- -->

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span :id="item.reference+'_check_'+index" @click="onConfirmEdition(item)" style="cursor: pointer; widht:20px; margin-right: 5px;" :style="item.entityPackageServiceId > 0 ? '' : 'opacity: 0.5;'" v-show="item.editable && !checkInputs" v-bind="attrs" v-on="on">
                                            <img src="/images/_SVGs/bo/check.svg"  onload="SVGInject(this)" width="15" height="15" fill="green"/>
                                        </span>
                                        <span :id="item.reference+'_check_no_drop_'+index" style="cursor: no-drop; widht:20px; margin-right: 5px;" :style="item.entityPackageServiceId > 0 ? '' : 'opacity: 0.5;'" v-show="item.editable && checkInputs" v-bind="attrs" v-on="on">
                                            <img src="/images/_SVGs/bo/check.svg"  onload="SVGInject(this)" width="15" height="15" fill="gray"/>
                                        </span>
                                    </template>
                                    <span>{{$t('backoffice.actions.record')}} </span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span :id="item.reference+'_close_'+index" style="cursor: pointer; widht:20px;" @click="onCancelEditableRow(item.entityPackageServiceId)" v-show="item.editable" v-bind="attrs" v-on="on">
                                            <img src="/images/_SVGs/environmental/fechar.svg"  onload="SVGInject(this)" width="25" height="25" fill="red"/>
                                        </span>
                                    </template>
                                    <span>{{$t('backoffice.actions.cancel')}} </span>
                                </v-tooltip>

                            </div>
                        </template>
                    </v-data-table>
                </v-col>

                <v-col cols="12" v-if="activeDetails">
                    <span style="font-size: 18px">{{$t('module-budget.main-budget.service-pack.details-title')}}</span>
                    <div>
                        <SearchForm type="textonly" :showAdvancedSearch="false" @on-search="onSearchByTextDetails"/>
                    </div>
                    <v-data-table
                        ref="ref_details_table"
                        v-if="tableDetalIsReady"
                        class="tablepackservicedetail"
                        item-key="entityPackageServiceDetailId"
                        :headers="servicePacksHeadersDetails"
                        :items="servicePacksItemsDetails"
                        :page="pageDetails"
                        :pageCount="numberOfPagesDetails"
                        :options.sync="optionsDetails"
                        :server-items-length="totalItemsDetails"
                        :footer-props="{
                            showFirstLastPage: true,
                            'items-per-page-options': [5, 10, 20]
                        }"
                        :key="tableKey"
                    >
                        <template v-slot:[`item.packageTypeId`]="{ item }">
                            <v-form @submit.prevent v-if="item.editable" v-model="validationsDetails.packageTypeId">
                                <v-select
                                    ref="package_type_id"
                                    v-model="item.packageTypeId"
                                    :items="packageType.map(e => ({ text: e.name, value: Number(e.value) }))"
                                    :rules="formRules.defaultRules"
                                    @change="onChangePackageTypeId(item)"
                                ></v-select>
                            </v-form>
                            <span v-else>
                                {{transformPackageTypeIdToName(item.packageTypeId)}}
                            </span>
                        </template>

                        <template v-slot:[`item.reference`]="{ item }">
                            <v-form @submit.prevent v-if="item.editable" v-model="validationsDetails.ref">
                                <v-text-field
                                    ref="package_ref"
                                    v-model="item.reference"
                                    :rules="formRules.defaultRules"
                                    :placeholder="$t('module-budget.main-budget.service-pack.ref-placeholder')"
                                ></v-text-field>
                            </v-form>
                            <span v-else>
                                {{item.reference}}
                            </span>
                        </template>

                        <template v-slot:[`item.description`]="{ item }">
                            <v-form @submit.prevent v-if="item.editable" v-model="validationsDetails.desc">
                                <v-text-field
                                    ref="package_desc"
                                    v-model="item.description"
                                    :rules="formRules.defaultRules"
                                    :placeholder="$t('module-budget.main-budget.service-pack.desc-placeholder')"
                                ></v-text-field>
                            </v-form>
                            <span v-else>
                                {{item.description}}
                            </span>
                        </template>

                        <template v-slot:[`item.quantity`]="{ item }">
                            <v-form @submit.prevent v-if="item.editable" v-model="validationsDetails.qty">
                                <v-text-field
                                    ref="package_qty"
                                    v-if="item.packageTypeId == 2"
                                    v-model="item.quantity"
                                    :rules="formRules.quantity"
                                    type="number"
                                ></v-text-field>
                                <span v-else>
                                    {{item.quantity == 0 ? '' : item.quantity}}
                                </span>
                            </v-form>
                            <span v-else>
                                {{item.quantity == 0 ? '' : item.quantity}}
                            </span>
                        </template>

                        <template v-slot:[`item.hours`]="{ item }">
                            <v-form @submit.prevent v-if="item.editable && item.packageTypeId != 2" v-model="validationsDetails.hours">
                                <v-text-field
                                    ref="package_hours"
                                    v-if="item.packageTypeId == 1"
                                    v-model="item.hours"
                                    :rules="formRules.defaultRules"
                                    type="number"
                                    append-icon="mdi-clock-time-four-outline"
                                    @change="onChangeHoursAndMinutesDetails(item)"
                                ></v-text-field>
                                <span v-else>
                                    {{item.hours == 0 && item.packageTypeId == 2 ? '' :  Number(item.hours)}}
                                </span>
                            </v-form>
                            <span v-else>
                                {{item.hours == 0 && item.packageTypeId == 2 ? '' :  Number(item.hours)}}
                            </span>
                        </template>

                        <template v-slot:[`item.minutes`]="{ item }">
                            <v-form @submit.prevent v-if="item.editable && item.packageTypeId != 2" v-model="validationsDetails.minutes">
                                <v-text-field
                                    ref="package_minutes"
                                    v-if="item.packageTypeId == 1"
                                    v-model="item.minutes"
                                    :rules="formRules.defaultRules"
                                    type="number"
                                    append-icon="mdi-clock-time-four-outline"
                                    @change="onChangeHoursAndMinutesDetails(item)"
                                ></v-text-field>
                                <span v-else>
                                    {{item.minutes == 0 && item.packageTypeId == 2 ? '' : Number(item.minutes)}}
                                </span>
                            </v-form>
                            <span v-else>
                                {{item.minutes == 0 && item.packageTypeId == 2 ? '' : Number(item.minutes)}}
                            </span>
                        </template>

                        <template v-slot:[`item.detailCostPrice`]="{ item }">
                            <v-form @submit.prevent v-if="item.editable && item.packageTypeId != 1" v-model="validationsDetails.costPrice">
                                <v-text-field
                                    ref="package_cost_price"
                                    v-model="item.detailCostPrice"
                                    :rules="formRules.defaultRules"
                                    type="number"
                                    @keypress="onlyNumberRule"
                                    append-icon="mdi-currency-eur"
                                ></v-text-field>
                            </v-form>
                            <span v-else>
                                {{item.detailCostPrice | currency}}
                            </span>
                        </template>

                        <template v-slot:[`item.detailSellPrice`]="{ item }">
                            <v-form @submit.prevent v-if="item.editable && item.packageTypeId != 1" v-model="validationsDetails.sellPrice">
                                <v-text-field
                                    ref="package_sell_price"
                                    v-model="item.detailSellPrice"
                                    :rules="formRules.defaultRules"
                                    type="number"
                                    @keypress="onlyNumberRule"
                                    append-icon="mdi-currency-eur"
                                ></v-text-field>
                            </v-form>
                            <span v-else>
                                {{item.detailSellPrice | currency}}
                            </span>
                        </template>

                        <template v-slot:[`item.actions`]="{ item, index }">
                            <div class="div-actions">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span :id="item.reference+'_check_edit_'+index" @click="onEditRowDetails(item.entityPackageServiceDetailId)" style="cursor: pointer;" v-bind="attrs" v-on="on" v-show="item.editable == false">
                                            <img src="/images/_SVGs/bo/edit_pencil.svg" onload="SVGInject(this)" width="20" height="20"/>
                                        </span>
                                    </template>
                                    <span>{{$t('module-budget.main-budget.service-pack.edit-pack')}}</span>
                                </v-tooltip>
                                <span  v-show="item.editable == false">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span :id="item.reference+'_remove_'+index" @click="onDeleteRowDetail(item)" style="cursor: pointer;" class="mr-2 p-0" v-bind="attrs" v-on="on">
                                            <img src="/images/_SVGs/bo/remove.svg" alt="remover" onload="SVGInject(this)" width="30" height="30" class="circle"/>
                                        </span>
                                    </template>
                                    <span>{{$t('module-budget.main-budget.service-pack.remove-pack')}}</span>
                                </v-tooltip>
                                </span>
                                <!-- -->

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span :id="item.reference+'_check_'+index" @click="onConfirmEditionDetail(item)" style="cursor: pointer; widht:20px; margin-right: 5px;" :style="item.entityPackageServiceDetailId > 0 ? '' : 'opacity: 0.5;'" v-show="item.editable && !checkInputsDetails" v-bind="attrs" v-on="on">
                                            <img src="/images/_SVGs/bo/check.svg"  onload="SVGInject(this)" width="15" height="15" fill="green"/>
                                        </span>
                                        <span :id="item.reference+'_check_no_drop_'+index" style="cursor: no-drop; widht:20px; margin-right: 5px;" :style="item.entityPackageServiceDetailId > 0 ? '' : 'opacity: 0.5;'" v-show="item.editable && checkInputsDetails" v-bind="attrs" v-on="on">
                                            <img src="/images/_SVGs/bo/check.svg"  onload="SVGInject(this)" width="15" height="15" fill="gray"/>
                                        </span>
                                    </template>
                                    <span>{{$t('backoffice.actions.record')}} </span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span :id="item.reference+'_close_'+index" style="cursor: pointer; widht:20px;" @click="onCancelEditableRowDetail(item.entityPackageServiceDetailId)" v-show="item.editable" v-bind="attrs" v-on="on">
                                            <img src="/images/_SVGs/environmental/fechar.svg"  onload="SVGInject(this)" width="25" height="25" fill="red"/>
                                        </span>
                                    </template>
                                    <span>{{$t('backoffice.actions.cancel')}} </span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>

                    <v-col cols="12" class="d-flex p-0">
                        <v-btn
                            fab
                            ref="ref_btn_plus_dtl"
                            dark
                            x-small
                            :color="blockAddBtnDetail ? '#eeeeee' : '#F59534'"
                            rounded
                            class="add-btn"
                            style="min-width: 30px !important"
                            :style="blockAddBtnDetail ? 'cursor: no-drop' : ''"
                            @click="blockAddBtnDetail ? '' : addNewDetailRow()"
                            :readonly="blockAddBtnDetail"
                        >
                            <v-icon :style="blockAddBtnDetail ? 'color: grey' : 'color: white'">
                                mdi-plus
                            </v-icon>
                        </v-btn>
                        <span @click="blockAddBtnDetail ? '' : addNewDetailRow()" class="ml-3 btn-span mt-1" style="cursor: pointer" :style="blockAddBtnDetail ? 'cursor: no-drop' : ''">{{$t('module-budget.main-budget.service-pack.add-detail-service-pack')}}</span>
                    </v-col>
                </v-col>
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn color="" class="danger-button" text @click="onCancelShowPacksList">
                        <span>{{$t('close')}}</span>
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn :disabled="servicePacksItems.some(e => e.editable === true) || selected.length == 0" class="primary-button" text @click="onConfirmShowPacksList">
                        <span>{{$t('module-budget.main-budget.service-pack.add-to-estimate')}}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal v-model="modalMessage.show" :persistent="true" :title="modalMessage.title" modal-width="400px" :iconColor="modalMessage.iconColor" :iconName="modalMessage.iconName">
            <template v-slot:modal-body>
                <span v-if="modalMessage.type === 'remove'|| modalMessage.type === 'remove-detail'">
                    {{$t('module-budget.main-budget.service-pack.modal-message.remove-msg1') + ' ' + modalMessage.item.description + $t('module-budget.main-budget.service-pack.modal-message.remove-msg2')}}
                </span>
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn color="" class="danger-button" text @click="onRejectModalMessage(modalMessage.type)">
                        <span style="text-transform: capitalize">{{$t('no')}}</span>
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn class="primary-button" text @click="onConfirmModalMessage(modalMessage.type)">
                        <span style="text-transform: capitalize">{{$t('yes')}}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>
  </div>
</template>

<script>
import {required} from '@src/utils/validations.js';
import {
    EntityServicesCreatePackageService,
    EntityServicesDeleteEntityPackageService,
    EntityServicesDeleteEntityPackageServiceDetail,
    EntityServicesGetPackageServices,
    EntityServicesGetPackageServicesAllDetails,
    EntityServicesGetPackageServicesDetails,
    EntityServicesPutPackageServicesDetail,
    EntityServicesUpdateEntityPackageService,
} from '@services/backoffice/Entities/EntityServices'
import {GenericServicesGetDropdowns} from "@services/GenericServices";
import BaseModal from "@components/shared/widgets/BaseModal.vue";

export default {
    props: {
        showPacksList: { type: Boolean , default: false }
    },

    components: {
        BaseModal,
        SearchForm: () => import('@components/backoffice/widgets/SearchForm')
    },

    data() {
        return {
            showThePacksList: false,
            tablePackIsReady: true,
            servicePacksHeaders: [
                { text: this.$t('module-budget.main-budget.service-pack.datatable-headers.ref'), value: 'reference',  class: "header-table-color", width: '120' },
                { text: this.$t('module-budget.main-budget.service-pack.datatable-headers.desc'), value: 'description',  class: "header-table-color", width: '300' },
                { text: this.$t('module-budget.main-budget.service-pack.datatable-headers.status'), value: 'isActive',  class: "header-table-color" },
                { text: this.$t('module-budget.main-budget.service-pack.datatable-headers.time'), value: 'totalTime',  class: "header-table-color" },
                { text: this.$t('module-budget.main-budget.service-pack.datatable-headers.price'), value: 'totalPrice',  class: "header-table-color" },
                { text: this.$t('module-budget.main-budget.service-pack.datatable-headers.default-estimate'), value: 'isDefaultQuotation',  class: "header-table-color" },
                { text: '', value: 'actions', sortable: false,  class: "header-table-color" }
            ],
            servicePacksItems: [],
            isSelectable: true,
            selected: [],
            modalMessage: {
                show: false,
                item: {},
                type: '',
                iconColor: '',
                iconName: '',
                title: this.$t('heads-up')
            },
            blockAddBtn: false,
            formRules: {
                defaultRules: [required],
                quantity: [required, v => v && Number(v) >= 0 || this.$t('backoffice.rules.invalid', { field: ''})],
            },
            validations: {
                desc: false,
                ref: false,
                time: false,
                price: false
            },
            hoursControlMenu: false,
            activeDetails: false,

            page: 1,
            numberOfPages: 0,
            options: { page: 1, itemsPerPage: 10 },
            totalItems: 0,
            tableFilters: {},
            tableFiltersOld: {},

            servicePacksHeadersDetails: [
                { text: this.$t('module-budget.main-budget.service-pack.datatable-details-headers.type'), value: 'packageTypeId', class: "header-table-color", width: '100' },
                // { text: this.$t('module-budget.main-budget.service-pack.datatable-details-headers.desc'), value: 'packageType',  class: "header-table-color" },
                { text: this.$t('module-budget.main-budget.service-pack.datatable-details-headers.ref'), value: 'reference', class: "header-table-color", width: '120' },
                { text: this.$t('module-budget.main-budget.service-pack.datatable-details-headers.desc'), value: 'description', class: "header-table-color", width: '300' },
                { text: this.$t('module-budget.main-budget.service-pack.datatable-details-headers.qty'), value: 'quantity', class: "header-table-color", width: '120' },
                { text: this.$t('module-budget.main-budget.service-pack.datatable-details-headers.hours'), value: 'hours', class: "header-table-color", width: '100' },
                { text: this.$t('module-budget.main-budget.service-pack.datatable-details-headers.minutes'), value: 'minutes', class: "header-table-color", width: '100' },
                { text: this.$t('module-budget.main-budget.service-pack.datatable-details-headers.cost-price'), value: 'detailCostPrice', class: "header-table-color", width: '150' },
                { text: this.$t('module-budget.main-budget.service-pack.datatable-details-headers.sell-price'), value: 'detailSellPrice', class: "header-table-color", width: '150' },
                { text: '', value: 'actions', width: '120', sortable: false, class: "header-table-color" }
            ],
            servicePacksItemsDetails: [],

            tableDetailsFilters: {},
            tableDetailsFiltersOld: {},
            pageDetails: 1,
            numberOfPagesDetails: 0,
            optionsDetails: { page: 1, itemsPerPage: 10 },
            totalItemsDetails: 0,
            packageType: [],
            blockAddBtnDetail: false,
            validationsDetails: {
                packageTypeId: false,
                ref: false,
                desc: false,
                qty: false,
                hours: false,
                minutes: false,
                costPrice: false,
                sellPrice: false
            },
            tableDetalIsReady: true,
            isNewRowDetail: false,
            packageInEdit: {},
            packageDetailInEdit: {},
            hideFooterAndSearch: false,
            tableKey: 0
        }
    },

    watch: {
        showPacksList: {
            handler: function(newValue, oldValue) {
                this.showThePacksList = newValue;
                return newValue
            }, deep: true, immediate: true
        },
        "options.page": {
            handler() {
                this.alterTable(this.options);
            },
        },
        "options.itemsPerPage": {
            handler() {
                this.alterTable(this.options);
            },
        },
        "options.sortBy":{
            handler() {
                this.alterTable(this.options);
            },
        },
        "optionsDetails.page": {
            handler() {
                if(!this.isNewRowDetail) {
                    this.alterTableDetails(this.optionsDetails);
                }
            },
        },
        "optionsDetails.itemsPerPage": {
            handler() {
                if(!this.isNewRowDetail) {
                    this.alterTableDetails(this.optionsDetails);
                }
            },
        },
        "optionsDetails.sortBy":{
            handler() {
                if(!this.isNewRowDetail) {
                    this.alterTableDetails(this.optionsDetails);
                }
            },
        },
    },

    computed: {
        checkInputs() {
            return this.checkInputsBeforeSave();
        },
        entityId() {
            const initialState = this.$store.getters['auth/getState']
            if(initialState) {
                return initialState.entityParent
            }
            return '';
        },
        checkInputsDetails() {
            return this.checkInputsDetailsBeforeSave();
        },
    },

    methods: {
        getTheEntityPackageServices(editableId, editableDetails) {
            this.$store.commit('loadings/setStateLoadingTemplate', true)

            if(this.$route.name == 'budget-summary-edit') {
                this.tableFilters['quotationId'] = this.$route.params.id;
            }

            EntityServicesGetPackageServices(this.entityId, this.tableFilters)
                .then(response => {
                    if(response.data.result && response.data.result.length > 0) {
                        let res = response.data.result;
                        res.forEach(element => {
                            if(editableId) {
                                if(String(element.entityPackageServiceId) == String(editableId)) {
                                    Object.assign(element, { editable: true, details: editableDetails })
                                } else {
                                    Object.assign(element, { editable: false })
                                }
                            } else {
                                Object.assign(element, { editable: false })
                            }
                        })
                        this.servicePacksItems = res;
                    } else {
                        this.servicePacksItems = [];
                    }
                    if(response.data) {
                        this.totalItems = response.data.totalRecords;
                        this.page = response.data.currentPage;
                        this.numberOfPages = response.data.currentPage.totalPages;
                        this.options.page = response.data.currentPage;
                        this.options.itemsPerPage = response.data.pageSize;
                    } else {
                        this.totalItems = 0;
                        this.page = 1;
                        this.numberOfPages = 1;
                        this.options.page = 1;
                        this.options.itemsPerPage = 10;
                    }

                    if(editableId) {
                      this.tableKey += 1;
                    }
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error('Error in EntityServicesGetPackageServices', error);
                })
                .finally(() => {
                    this.checkInitialState();
                    this.$store.commit('loadings/setStateLoadingTemplate', false)
                })
        },
        checkInitialState() {
              this.servicePacksItems.forEach(element => {
                  const getBs = this.$store.getters['budget/getBudgetSummary'];
                  getBs.operations.values.forEach(op => {
                      if(op.entityPackageServiceId == element.entityPackageServiceId) {
                          this.selected.push(element);
                          this.$store.commit('budget/setStateSelectedPackageServices', this.selected);
                      }
                  });
                  getBs.parts.values.forEach(pt => {
                      if(pt.entityPackageServiceId == element.entityPackageServiceId) {
                          this.selected.push(element);
                          this.$store.commit('budget/setStateSelectedPackageServices', this.selected);
                      }
                  });
              })
        },
        alterTable(filters) {
            this.itemsPerPage = filters.itemsPerPage;
            let sort = ''

            if(filters.sortDesc[0] == true){
                sort = 'DESC';
            }else if(filters.sortDesc[0] == false){
                sort = 'ASC';
            }

            Object.assign(this.tableFilters, {
                    pageSize: filters.itemsPerPage,
                    currentPage: filters.page,
                    orderField: filters.sortBy[0] ? filters.sortBy[0] : '',
                    orderBy: sort
                }
            )
            this.getTheEntityPackageServices();
        },
        onSearchByText(params) {
            this.tableFiltersOld = _.cloneDeep(this.tableFilters);

            this.tableFilters = {
                searchText: params.searchText,
                pageSize: this.itemsPerPage,
                currentPage: this.page,
                orderField: this.tableFiltersOld?.sortBy ? this.tableFiltersOld.sortBy : '',
                orderBy: this.tableFiltersOld?.sort ? this.tableFiltersOld.sort : '',
            };

            const checkFilters = this.$compareObjects.compareTwoObjects(this.tableFiltersOld, this.tableFilters);
            if(!checkFilters) {
                this.getTheEntityPackageServices();
            }
        },
        onCancelShowPacksList() {
            for(let key in this.servicePacksItems) {
                if(this.servicePacksItems[key].editable == true) {
                    this.onCancelEditableRow(this.servicePacksItems[key].entityPackageServiceId);
                }
            }
            this.showThePacksList = false;
            this.$emit('show-packs-list-changed', false, 'close');
        },
        onConfirmShowPacksList() {
            this.showThePacksList = false;
            this.$emit('show-packs-list-changed', false);
            // if(this.selected.length > 0) {
            // }
            this.getAllPackageServicesDetails();
        },
        getColor(status) {
            if (status) return "green";
            else if (!status) return "red";
            else return "orange";
        },
        async addNewRow() {
            this.blockAddBtn = true;
            if(!this.servicePacksItems.some(e => e.editable === true)) {
                $(`.v-data-table__wrapper table tbody tr`).each(function(index, tr) {
                    tr.classList.add("d-none");
                });
                this.hideFooterAndSearch = true;
                const newRow = { entityPackageServiceId: 0, reference: '', description: '', isActive: false, totalTime: '00:00', totalPrice: '0.00', isDefaultQuotation: false, details: [], editable: true };
                this.servicePacksItems.push(newRow);
            };

            this.servicePacksHeaders.forEach(header => {
              Object.assign(header, { sortable: false })
            })

            await this.$nextTick();

            if(this.servicePacksItems.length === 1) {
                this.totalItems = 1;
            }
        },
        onCancelEditableRow(rowId) {
            let copyList = _.cloneDeep(this.servicePacksItems);

            if(rowId === 0){
                $(`.v-data-table__wrapper table tbody tr`).each(function(index, tr) {
                    tr.classList.remove("d-none");
                });
                this.hideFooterAndSearch = false;
                copyList.splice(-1);
            } else {
                for(let key in copyList) {
                    if(copyList[key].entityPackageServiceId == rowId) {
                        Object.assign(copyList[key], {
                            ...this.packageInEdit,
                            editable: false
                        });
                        $(`.v-data-table__wrapper table tbody tr`).each(function(index, tr) {
                            tr.classList.remove("d-none");
                        });
                        this.hideFooterAndSearch = false;
                    } else {
                        Object.assign(copyList[key], {
                            editable: false
                        });
                    }
                }
            }
            this.servicePacksItems = _.cloneDeep(copyList);
            this.blockAddBtn = false;
            this.activeDetails = false;
            this.blockAddBtnDetail = false;
            this.clearPackageInEdit();

            this.servicePacksHeaders.forEach(header => {
              if(header.value !== 'actions') {
                Object.assign(header, { sortable: true })
              }
            })
        },
        clearPackageInEdit() {
            this.packageInEdit = {};
        },
        onConfirmEdition(item) {
            this.servicePacksHeaders.forEach(header => {
              if(header.value !== 'actions') {
                Object.assign(header, { sortable: true })
              }
            })
            if(this.checkInputs) {
                return;
            }
            if(this.activeDetails) {
                const findEditable = this.servicePacksItemsDetails.some(e => e.editable === true);
                if(findEditable) {
                    return;
                }
            }
            if(item.entityPackageServiceId == 0) {
                this.handleCreateNewPackService(item);
            } else {
                this.handleUpdateNewPackService(item);
            }
        },
        onEditRow(rowId) {
            if(this.servicePacksItems.some(e => e.editable === true)) {
                return;
            }

            this.servicePacksHeaders.forEach(header => {
              Object.assign(header, { sortable: false })
            });

            this.blockAddBtn = true;
            const findIndex = this.servicePacksItems.findIndex(el => el.entityPackageServiceId === rowId);
            if(findIndex > -1) {
                this.activeDetails = true;
                this.servicePacksItems[findIndex].editable = true;
                this.getEntityPackageServiceDetails(this.servicePacksItems[findIndex])
                this.packageInEdit = _.cloneDeep(this.servicePacksItems[findIndex]);
                $(`.v-data-table__wrapper table tbody tr`).each(function(index, tr) {
                    if(index != findIndex) {
                        tr.classList.add("d-none");
                    }
                });
                this.hideFooterAndSearch = true;
            }
        },
        onDeleteRow(item) {
            this.modalMessage.iconColor = 'warning';
            this.modalMessage.iconName = 'mdi-alert-outline';
            this.modalMessage.type = 'remove';
            this.modalMessage.item = item;
            this.modalMessage.show = true;
        },
        clearModalMessage() {
            this.modalMessage = {
                show: false,
                item: {},
                type: '',
                iconColor: '',
                iconName: '',
                title: this.$t('heads-up')
            };
        },
        async onConfirmModalMessage(type) {
            if(type == 'remove') {
                const cloneItem = _.cloneDeep(this.modalMessage.item);
                this.handleDeleteNewPackService(cloneItem);
            } else if(type == 'remove-detail') {
                const cloneItem = _.cloneDeep(this.modalMessage.item);

                this.servicePacksItemsDetails = this.servicePacksItemsDetails.filter(e => e.entityPackageServiceDetailId != cloneItem.entityPackageServiceDetailId)

                const findIndex = this.servicePacksItems.findIndex(el => el.editable == true);
                this.servicePacksItems[findIndex].details = this.servicePacksItemsDetails;

                const newItem = this.servicePacksItems[findIndex];
                const isDetail = true;
                // this.handleUpdateNewPackService(newItem, isDetail);
                this.handleDeleteDetail(newItem, cloneItem.entityPackageServiceDetailId, isDetail)
            }

            await this.$nextTick();

            this.clearModalMessage();
        },
        onRejectModalMessage(type) {
            this.clearModalMessage();
        },
        checkInputsBeforeSave() {
            // if(this.validations.desc === false || this.validations.ref === false || this.validations.time === false || this.validations.price === false) {
            //     return true;
            // } else {
            //     return false;
            // }
            const findEditable = this.servicePacksItemsDetails.some(e => e.editable === true);
            return this.validations.desc === false || this.validations.ref === false || findEditable;
        },
        handleCreateNewPackService(item) {
            this.$store.commit('loadings/setStateLoadingTemplate', true)

            const body = {
              "reference": item.reference,
              "description": item.description,
              "isDefaultQuotation": item.isDefaultQuotation,
              "isActive": item.isActive,
            }

            EntityServicesCreatePackageService(this.entityId, body)
                .then(response => {
                    const findIndex = this.servicePacksItems.findIndex(el => el.entityPackageServiceId === item.entityPackageServiceId);
                    const res = response.data.result;
                    this.servicePacksItems[findIndex].entityPackageServiceId = res.id;
                    this.servicePacksItems[findIndex].editable = false;
                    this.blockAddBtn = false;
                    $(`.v-data-table__wrapper table tbody tr`).each(function(index, tr) {
                        tr.classList.remove("d-none");
                    });
                    this.hideFooterAndSearch = false;
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error('Error in EntityServicesCreatePackageService', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false)
                })
        },
        handleUpdateNewPackService(item, isDetail) {
            this.$store.commit('loadings/setStateLoadingTemplate', true)
            let details = item.details ? item.details : [];

            if(details.length > 0) {
                details = this.servicePacksItemsDetails;
                details.forEach(e => {
                    if(e.packageTypeId == 1) {
                        Object.assign(e, {
                            detailCostPrice: '',
                            detailSellPrice: ''
                        })
                    } else {
                        Object.assign(e, {
                            detailTime: '',
                        })
                    }
                })
            }

            const body = {
                "reference": item.reference,
                "description": item.description,
                "isDefaultQuotation": item.isDefaultQuotation,
                "isActive": item.isActive,
                // "details": details
            }

            let editableId = '';
            let editableDetails = '';

            EntityServicesUpdateEntityPackageService(item.entityPackageServiceId, body)
                .then(response => {
                    if(isDetail) {
                        const findDetailIndex = this.servicePacksItemsDetails.findIndex(e => e.editable === true);
                        if(findDetailIndex > -1) {
                            this.servicePacksItemsDetails[findDetailIndex].editable = false;
                        }

                        const findIndex = this.servicePacksItems.findIndex(el => el.entityPackageServiceId === item.entityPackageServiceId);
                        if(findIndex > -1) {
                            this.servicePacksItems[findIndex].details = item.details;
                            if(isDetail) {
                                editableId = this.servicePacksItems[findIndex].entityPackageServiceId;
                                editableDetails = item.details;
                            }
                        }

                        this.blockAddBtnDetail = false;
                        this.isNewRowDetail = false;

                        this.getEntityPackageServiceDetails(item);
                    } else {
                        const findIndex = this.servicePacksItems.findIndex(el => el.entityPackageServiceId === item.entityPackageServiceId);
                        this.servicePacksItems[findIndex].editable = false;
                        this.blockAddBtn = false;
                        this.activeDetails = false;
                        $(`.v-data-table__wrapper table tbody tr`).each(function(index, tr) {
                            tr.classList.remove("d-none");
                        });
                        this.hideFooterAndSearch = false;
                    }
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error('Error in EntityServicesUpdateEntityPackageService', error);
                })
                .finally(() => {
                    if(isDetail) {
                        this.getTheEntityPackageServices(editableId, editableDetails);
                    }
                    this.$store.commit('loadings/setStateLoadingTemplate', false)
                })
        },
        handleDeleteNewPackService(item) {
            this.$store.commit('loadings/setStateLoadingTemplate', true)
            EntityServicesDeleteEntityPackageService(item.entityPackageServiceId)
                .then(response => {
                    this.servicePacksItems = this.servicePacksItems.filter(el => el.entityPackageServiceId != item.entityPackageServiceId)
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error('Error in EntityServicesDeleteEntityPackageService', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false)
                })
        },
        getEntityPackageServiceDetails(item) {
            this.$store.commit('loadings/setStateLoadingTemplate', true)
            EntityServicesGetPackageServicesDetails(item.entityPackageServiceId, this.tableDetailsFilters)
                .then(response => {
                    if(response.data && response.data != '') {
                        if(response.data.result && response.data.result.length > 0) {
                            let res = response.data.result;
                            res.forEach(element => {
                                if(element.detailTime) {
                                    let splitTime = element.detailTime.split(':');
                                    let hours = splitTime[0];
                                    let minutes = splitTime[1];
                                    Object.assign(element, { editable: false, hours: hours, minutes: minutes })
                                } else {
                                    Object.assign(element, { editable: false, hours: '0', minutes: '0' })
                                }

                                if(!element.detailCostPrice) {
                                    Object.assign(element, { detailCostPrice: 0 })
                                }
                                if(!element.detailSellPrice) {
                                    Object.assign(element, { detailSellPrice: 0 })
                                }
                            })
                            this.servicePacksItemsDetails = res;
                            const findIndexPack = this.servicePacksItems.findIndex(p => p.entityPackageServiceId == item.entityPackageServiceId);
                            if(findIndexPack > -1) {
                                this.servicePacksItems[findIndexPack].details = res;
                            }
                        }
                        this.totalItemsDetails = response.data.totalRecords;
                        this.pageDetails = response.data.currentPage;
                        this.numberOfPagesDetails = response.data.currentPage.totalPages;
                        this.optionsDetails.page = response.data.currentPage;
                        this.optionsDetails.itemsPerPage = response.data.pageSize;
                    } else {
                        this.servicePacksItemsDetails = [];
                        this.totalItemsDetails = 0;
                        this.pageDetails = 1;
                        this.numberOfPagesDetails = 1;
                        this.optionsDetails.page = 1;
                        this.optionsDetails.itemsPerPage = 10;
                    }
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error('Error in EntityServicesGetPackageServicesDetails', error);
                })
                .finally(() => {
                    this.getGenericDrops();
                    this.$store.commit('loadings/setStateLoadingTemplate', false)
                })
        },
        getGenericDrops() {
            GenericServicesGetDropdowns()
                .then(response => {
                    this.packageType = response.data.packageTypeEnum;
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error('error to get generic drops', error);
                })
                .finally(() => {
                    if(this.servicePacksItemsDetails && this.servicePacksItemsDetails.length <= 0) {
                        setTimeout(() => {
                            if(this.$refs.ref_btn_plus_dtl) {
                                this.$refs.ref_btn_plus_dtl.click();
                            }
                        }, 500);
                    }
                })
        },
        onSearchByTextDetails(params) {
            this.tableDetailsFiltersOld = _.cloneDeep(this.tableDetailsFilters);

            this.tableDetailsFilters = {
                searchText: params.searchText,
                pageSize: this.optionsDetails.itemsPerPage,
                currentPage: this.optionsDetails.page,
                orderField: this.tableDetailsFiltersOld?.sortBy ? this.tableDetailsFiltersOld.sortBy : '',
                orderBy: this.tableDetailsFiltersOld?.sort ? this.tableDetailsFiltersOld.sort : '',
            };

            const checkFilters = this.$compareObjects.compareTwoObjects(this.tableDetailsFiltersOld, this.tableDetailsFilters);
            if(!checkFilters) {
                const findIndex = this.servicePacksItems.findIndex(el => el.editable == true);
                this.getEntityPackageServiceDetails(this.servicePacksItems[findIndex]);
            }
        },
        alterTableDetails(filters) {
            this.optionsDetails.itemsPerPage = filters.itemsPerPage;
            let sort = ''

            if(filters.sortDesc[0] == true){
                sort = 'DESC';
            }else if(filters.sortDesc[0] == false){
                sort = 'ASC';
            }

            Object.assign(this.tableDetailsFilters, {
                    pageSize: filters.itemsPerPage,
                    currentPage: filters.page,
                    orderField: filters.sortBy[0] ? filters.sortBy[0] : '',
                    orderBy: sort
                }
            )
            const findIndex = this.servicePacksItems.findIndex(el => el.editable == true);
            this.getEntityPackageServiceDetails(this.servicePacksItems[findIndex]);
        },
        async addNewDetailRow() {
            this.tableDetalIsReady = false;
            this.blockAddBtnDetail = true;
            if(!this.servicePacksItemsDetails.some(e => e.editable === true) || this.servicePacksItemsDetails.length == 0) {
                if(this.servicePacksItemsDetails.length == 0) {
                    this.totalItemsDetails = 1;
                }
                this.isNewRowDetail = true;
                const newRow = {
                    "entityPackageServiceDetailId": 0,
                    "packageTypeId": 1,
                    "packageType": "MO",
                    "reference": "",
                    "description": "",
                    "quantity": '0',
                    "detailTime": "00:00:00",
                    "hours": "0",
                    "minutes": "0",
                    "detailCostPrice": '0',
                    "detailSellPrice": '0',
                    editable: true
                };
                this.servicePacksItemsDetails.push(newRow);
                this.validationsDetails.costPrice = true;
                this.validationsDetails.sellPrice = true;
            };

            this.servicePacksHeadersDetails.forEach(header => {
              Object.assign(header, { sortable: false })
            });

            await this.$nextTick();

            this.tableDetalIsReady = true;
        },
        transformPackageTypeIdToName(id) {
            if(this.packageType.length > 0) {
                const findName = this.packageType.find(e => e.value == id);
                return findName.name;
            } else {
                return ''
            }
        },
        onEditRowDetails(rowId) {
            if(this.servicePacksItemsDetails.some(e => e.editable === true)) {
                return;
            }

            this.servicePacksHeadersDetails.forEach(header => {
              Object.assign(header, { sortable: false })
            });

            this.blockAddBtnDetail = true;
            const findIndex = this.servicePacksItemsDetails.findIndex(el => el.entityPackageServiceDetailId === rowId);
            if(findIndex > -1) {
                if(this.servicePacksItemsDetails[findIndex].packageTypeId == 2 && this.servicePacksItemsDetails[findIndex].quantity == 0) {
                    this.servicePacksItemsDetails[findIndex].quantity = '1';
                }
                this.servicePacksItemsDetails[findIndex].editable = true;
                this.packageDetailInEdit = _.cloneDeep(this.servicePacksItemsDetails[findIndex]);
                this.checkAllValidations(this.servicePacksItemsDetails[findIndex]);
            }
        },
        onDeleteRowDetail(item) {
            if(this.servicePacksItemsDetails.some(e => e.editable === true)) {
                return;
            }
            this.modalMessage.iconColor = 'warning';
            this.modalMessage.iconName = 'mdi-alert-outline';
            this.modalMessage.type = 'remove-detail';
            this.modalMessage.item = item;
            this.modalMessage.show = true;
        },
        onConfirmEditionDetail(item) {
            if(this.checkInputsDetails) {
                return;
            }

            this.servicePacksHeadersDetails.forEach(header => {
              if(header.value !== 'actions') {
                Object.assign(header, { sortable: true })
              }
            });

            const findIndex = this.servicePacksItems.findIndex(el => el.editable == true);
            // this.servicePacksItems[findIndex].details = _.cloneDeep(this.servicePacksItemsDetails)
            const newItem = this.servicePacksItems[findIndex];
            // const isDetail = true;
            // this.handleUpdateNewPackService(newItem, isDetail);

            this.handlePutNewDetail(item, newItem);
        },
        onCancelEditableRowDetail(rowId) {
            let copyList = _.cloneDeep(this.servicePacksItemsDetails);

            if(rowId === 0) {
                copyList.splice(-1);

            } else {
                for(let key in copyList) {
                    if(copyList[key].entityPackageServiceDetailId == rowId) {
                        Object.assign(copyList[key], {
                            ...this.packageDetailInEdit,
                            editable: false
                        });
                    } else {
                        Object.assign(copyList[key], {
                            editable: false
                        });
                    }
                }
            }
            this.servicePacksItemsDetails = _.cloneDeep(copyList);
            this.blockAddBtnDetail = false;
            this.isNewRowDetail = false;

            this.servicePacksHeadersDetails.forEach(header => {
              if(header.value !== 'actions') {
                Object.assign(header, { sortable: true })
              }
            });

            this.clearPackageDetailInEdit();
        },
        clearPackageDetailInEdit() {
            this.packageDetailInEdit = {};
        },
        checkInputsDetailsBeforeSave() {
            const areTrue = Object.values(this.validationsDetails).every(
                value => value === true
            );
            return !areTrue;
        },
        onChangeHoursAndMinutesDetails(item) {
            let newHour = '00';
            let newMinute = '00';
            let newDetailTime;

            if(item.hours != '') {
                newHour = item.hours;
            }

            if(item.minutes != '') {
                newMinute = item.minutes;
            }

            newDetailTime = newHour + ':' + newMinute + ':' + '00';
            const findIndex = this.servicePacksItemsDetails.findIndex(e => e.entityPackageServiceDetailId == item.entityPackageServiceDetailId);
            this.servicePacksItemsDetails[findIndex].detailTime = newDetailTime;
        },
        getAllPackageServicesDetails() {
            this.$store.commit('loadings/setStateLoadingTemplate', true)

            let body = '';
            if(this.selected.length > 0) {
              this.selected.forEach((item, index) => {
                if(index == 0) {
                  body += item.entityPackageServiceId
                } else {
                  body += ',' + item.entityPackageServiceId
                }
              });
            } else {
                this.transformPayloadToInsertOnEstimate([]);
                this.$store.commit('loadings/setStateLoadingTemplate', false)
                return;
            }

            this.$store.commit('budget/setStateSelectedPackageServices', this.selected);

            let quotationId = '';
            if(this.$route.name == 'budget-summary-edit') {
              quotationId = this.$route.params.id;
            }

            EntityServicesGetPackageServicesAllDetails(body, quotationId)
                .then(response => {
                    if(response.data.result && response.data.result.length > 0) {
                        this.transformPayloadToInsertOnEstimate(response.data.result);
                    }
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error('Error in EntityServicesGetPackageServicesAllDetails', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false)
                })
        },
        async transformPayloadToInsertOnEstimate(res) {
            let newHourValue = this.$store.getters['budget/getBudgetSummary'].operations.values[0].hourValue;
            let newlaborValues = this.$store.getters['budget/getBudgetSummary'].operations.values[0].laborValues;
            let newhourValueDefault = this.$store.getters['budget/getBudgetSummary'].operations.values[0].hourValueDefault;

            let operations = [];
            let parts = [];
            let newOperations = [];
            let newParts = []

            function timeToDecimal(t) {
              var arr = t.split(':');
              var dec = parseInt((arr[1]/6)*10, 10);
              return parseFloat(parseInt(arr[0], 10) + '.' + (dec<10?'0':'') + dec);
            }

            if(res != [] || res != '' || res != undefined) {
                if(this.$route.name == 'budget-summary-edit') {
                    res.forEach(item => {
                        if(item.packageTypeId == 1) {
                            operations.push(item);
                        }
                        if(item.packageTypeId == 2) {
                            parts.push(item)
                        }
                    });
                } else {
                    res.forEach(item => {
                        if(item.packageTypeId == 1 && !item.isSelected) {
                          operations.push(item);
                        }
                        if(item.packageTypeId == 2 && !item.isSelected) {
                          parts.push(item)
                        }
                    });
                }
            }

            if(operations.length > 0) {
                operations.forEach(element => {
                const splitTime = element.detailTime.split(':');
                const duration = {
                    hours: splitTime[0],
                    minutes: splitTime[1]
                }
                const time = timeToDecimal(splitTime[0] + ':' + splitTime[1]);
                const itemMpIdAndWorkId = "-998" + element.entityPackageServiceDetailId;
                const newElement = {
                    calculatedTime: time,
                    description: element.description,
                    discount: element.discount ? element.discount : 0,
                    duration: duration,
                    finalValue: element?.detailSellPrice ? element.detailSellPrice : 0,
                    hourValue: newHourValue,
                    isPreview: false,
                    itemMpId: itemMpIdAndWorkId,
                    korId: 7,
                    korText: element.description,
                    laborValues: newlaborValues,
                    names: [element.description],
                    reference: element.reference,
                    showServicePlan: '',
                    singleWorkTime: time,
                    totalWithoutVAT: element?.detailSellPrice ? element.detailSellPrice : 0,
                    workId: itemMpIdAndWorkId,
                    workPosCriteriaDescription: element.description,
                    workPosDescription: element.description,
                    entityPackageServiceId: element.entityPackageServiceId,
                    hourValueDefault: newhourValueDefault
                }
                newOperations.push(newElement)
            })
            }

            if(parts.length > 0) {
                parts.forEach((element, index) => {
                let fatherWorkId = '';
                const findWorkId = operations.find(op => op.entityPackageServiceId == element.entityPackageServiceId);
                if(findWorkId) {
                  fatherWorkId = "-998" + findWorkId.entityPackageServiceDetailId;
                }
                const itemMpIdAndWorkId = "-998" + element.entityPackageServiceDetailId;
                const newElement = {
                    brand: null,
                    brandId: null,
                    costPrice: element.detailCostPrice,
                    iamParts: [],
                    isSelected: true,
                    priceOriginal: element.detailSellPrice,
                    quantities: [{
                        id: null,
                        isSelected: true,
                        quantity: element.quantity
                    }],
                    discount: element.discount ? element.discount : 0,
                    isIam: false,
                    itemMpId: itemMpIdAndWorkId,
                    name: element.description,
                    price: element.detailSellPrice,
                    quantity: element.quantity,
                    reference: element.reference,
                    totalWithoutVAT: element.detailSellPrice,
                    workId: fatherWorkId,
                    entityPackageServiceId: element.entityPackageServiceId,
                    partId: element?.partId ? element.partId : '',
                    individualWorkId: "-998" + element.entityPackageServiceDetailId,
                    apiPartOrder: element.apiPartOrder ? element.apiPartOrder : index+1
                }

                newParts.push(newElement);
            })
            }

            const response = {
                operations: newOperations,
                parts: newParts
            }

            await this.$nextTick();
            this.$store.commit('budget/setStatePackageServices', response);
            this.$emit('package-services-transformed', response);
        },
        clearInfo() {
            this.selected = [];
            this.servicePacksItems = [];
            this.servicePacksItemsDetails = [];
        },
        onChangePackageTypeId(item) {
            const findIndex = this.servicePacksItemsDetails.findIndex(e => e.entityPackageServiceDetailId == item.entityPackageServiceDetailId);
            if(item.packageTypeId == 2) {
                this.servicePacksItemsDetails[findIndex].hours = '0';
                this.servicePacksItemsDetails[findIndex].minutes = '0';
                this.servicePacksItemsDetails[findIndex].quantity = '1';
                this.servicePacksItemsDetails[findIndex].detailTime = '00:00:00';
                this.servicePacksItemsDetails[findIndex].detailCostPrice = '0';
                this.servicePacksItemsDetails[findIndex].detailSellPrice = '0';
                this.validationsDetails.hours = true;
                this.validationsDetails.minutes = true;
            } else {
                this.servicePacksItemsDetails[findIndex].quantity = '0';
                this.servicePacksItemsDetails[findIndex].detailCostPrice = 0;
                this.servicePacksItemsDetails[findIndex].detailSellPrice = 0;
                this.validationsDetails.costPrice = true;
                this.validationsDetails.sellPrice = true;
            }
        },
        checkAllValidations(item) {
            if(item.packageTypeId == 2) {
                // PART
                this.validationsDetails.minutes = true;
                this.validationsDetails.hours = true;
            } else {
                // OPERATION
                this.validationsDetails.costPrice = true;
                this.validationsDetails.sellPrice = true;
                this.validationsDetails.quantity = true;
            }
        },
        handlePutNewDetail(detailItem, packageServiceItem) {
          let body = {
            "entityPackageServiceDetailId": detailItem.entityPackageServiceDetailId,
            "packageTypeID": detailItem.packageTypeId,
            "reference": detailItem.reference,
            "description": detailItem.description,
            "quantity": detailItem.quantity,
            "detailTime": detailItem.detailTime,
            "detailCostPrice": detailItem.detailCostPrice,
            "detailSellPrice": detailItem.detailSellPrice
          }

          if(detailItem.packageTypeId == 1) {
            body.detailCostPrice = '';
            body.detailSellPrice = '';
          } else {
            body.detailTime = ''
          }

          let editableId = '';
          let editableDetails = '';

          this.$store.commit('loadings/setStateLoadingTemplate', true)
          EntityServicesPutPackageServicesDetail(packageServiceItem.entityPackageServiceId, body)
            .then(response => {
              const findDetailIndex = this.servicePacksItemsDetails.findIndex(e => e.editable === true);
              if(findDetailIndex > -1) {
                this.servicePacksItemsDetails[findDetailIndex].editable = false;
              }

              const findIndex = this.servicePacksItems.findIndex(el => el.entityPackageServiceId === packageServiceItem.entityPackageServiceId);
              if(findIndex > -1) {
                  this.servicePacksItems[findIndex].details = packageServiceItem.details;
                  editableId = this.servicePacksItems[findIndex].entityPackageServiceId;
                  editableDetails = packageServiceItem.details;
              }

              this.blockAddBtnDetail = false;
              this.isNewRowDetail = false;

              this.getEntityPackageServiceDetails(packageServiceItem);
            })
            .catch(error => {
                this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                throw new Error('Error in EntityServicesPutPackageServicesDetail', error);
            })
            .finally(() => {
                this.getTheEntityPackageServices(editableId, editableDetails);
                this.$store.commit('loadings/setStateLoadingTemplate', false)
            })
        },
        handleDeleteDetail(servicePackItem, entityPackageServiceDetailId, isDetail) {
          this.$store.commit('loadings/setStateLoadingTemplate', true)
          EntityServicesDeleteEntityPackageServiceDetail(entityPackageServiceDetailId)
            .then(response => {
              this.blockAddBtnDetail = false;
              this.isNewRowDetail = false;
              this.getEntityPackageServiceDetails(servicePackItem);
            })
            .catch(error => {
                this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                throw new Error('Error in EntityServicesDeleteEntityPackageServiceDetail', error);
            })
            .finally(() => {
                this.$store.commit('loadings/setStateLoadingTemplate', false)
            })
        }
    },

    mounted() {
        this.showThePacksList = this.showPacksList;
        // this.getTheEntityPackageServices();
    }
}
</script>

<style lang="scss">
@import '@sass/_variables.scss';

::v-deep .circle{
    width: 40px !important;
    height: 40px !important;
    padding: 0 5px;
    background-color: var(--v-primary-base) !important;
    ::v-deep svg{
        path{
            fill: #fff;
        }
    }
}

    table {
        thead{
            tr{
                th{
                    border: 0;

                    &.header-table-color{
                        background-color: #F2F2F2 !important;
                        color:#9E9D9D !important;
                        font-weight: 500;
                    }
                }
            }
        }
        tbody{
            tr{
                td{
                    font-size: 12px;
                    border: 0;
                }
            }
        }
    }
</style>
